import PopupOffline from '../../components/PopupOffline/PopupOffline';
import './Offline.css'; 

const Offline = () => {
  return <div className={`container page_offline no-animation`}>
    <div className="content">
      <PopupOffline />
    </div>
  </div>;
};

export default Offline;